var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',{attrs:{"justify":"center","no-gutters":""}},[_c('kenm-a'),_c('kenm-b'),_c('kenm-c'),_c('kenm-d'),_c('kenm-e'),_c('kenm-f')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }